import { useEffect } from 'react';

import { useRouter } from 'next/router';
import { SearchOutlined } from '@ant-design/icons';

import { FLIGHT_SEARCH_QUERY_PARAM_KEYS } from '@views/flight/constants';
import { isDomesticFlight } from '@components/views/flight/utils';
import { FlightSearchBarActionType } from '@domain/flight/context/flight/actions';
import { formatDateForUrl } from '@domain/flight/utils/date';

import { StyledButton } from './styled';
import useFlightSearchBar from '../../context/flight';

const SearchFlightButton = () => {
  const { dispatch, state } = useFlightSearchBar();
  const router = useRouter();

  const handleSearchFlight = () => {
    dispatch({
      type: FlightSearchBarActionType.SET_IS_SUBMIT,
      payload: true,
    });
  };

  useEffect(() => {
    if (state.isValidFlightSearchBar) {
      const pathname = isDomesticFlight(
        state?.departureAirport || undefined,
        state?.arrivalAirport || undefined
      )
        ? '/ic-hat-ucuslari'
        : '/dis-hat-ucuslari';

      let query = {
        ...(state.startDate && {
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.departureDate]: formatDateForUrl(
            state.startDate
          ),
        }),
        ...(state.endDate && {
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.returnDate]: formatDateForUrl(
            state.endDate
          ),
        }),

        ...(!state.endDate
          ? {
              [FLIGHT_SEARCH_QUERY_PARAM_KEYS.isOneWay]: String(true),
            }
          : {
              [FLIGHT_SEARCH_QUERY_PARAM_KEYS.isOneWay]: String(false),
            }),

        ...(state.isDirectFlight && {
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.isDirectFlight]: String(1),
        }),

        ...(state.guestInfo && {
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.adults]:
            state.guestInfo.numberOfAdultGuests,
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.childs]:
            state.guestInfo.numberOfChildGuests,
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.infants]:
            state.guestInfo.numberOfInfantGuests,
        }),
      };
      if (state.departureAirport) {
        query = {
          ...query,
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.departureAirportCode]:
            state.departureAirport.airportCode,
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.isDomestic]: isDomesticFlight(
            state.departureAirport,
            state?.arrivalAirport || undefined
          )
            ? 'true'
            : 'false',
        };
        if (state.departureAirport?.isCity) {
          query = {
            ...query,
            [FLIGHT_SEARCH_QUERY_PARAM_KEYS.departureIsCity]: 1,
          };
        } else {
          delete query[FLIGHT_SEARCH_QUERY_PARAM_KEYS.departureIsCity];
        }
      }
      if (state.arrivalAirport) {
        query = {
          ...query,
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.arrivalAirportCode]:
            state.arrivalAirport.airportCode,
          [FLIGHT_SEARCH_QUERY_PARAM_KEYS.isDomestic]: isDomesticFlight(
            state.arrivalAirport,
            state?.departureAirport || undefined
          )
            ? 'true'
            : 'false',
        };
        if (state.arrivalAirport?.isCity) {
          query = {
            ...query,
            [FLIGHT_SEARCH_QUERY_PARAM_KEYS.arrivalIsCity]: 1,
          };
        } else {
          delete query[FLIGHT_SEARCH_QUERY_PARAM_KEYS.arrivalIsCity];
        }
      }

      if (state.cabinClass === 'All') {
        delete query['out-classes'];
        delete query['in-classes'];
      } else if (state.isOneWay) {
        query = {
          ...query,
          'out-classes': state.cabinClass,
        };
      } else {
        query = {
          ...query,
          'out-classes': state.cabinClass,
          'in-classes': state.cabinClass,
        };
      }

      router.push({
        pathname,
        query,
      });
    }
  }, [state.isValidFlightSearchBar]);

  return (
    <StyledButton
      onClick={handleSearchFlight}
      data-testid='flight-search-button'
    >
      <SearchOutlined />
      ARA
    </StyledButton>
  );
};

export default SearchFlightButton;
